<template>
  <div>
    <div class="repertorymsg">
      <div class="msg">
        <i class="circle"></i>
        查询信息
      </div>
      <div class="datadetails">
        <div v-for="(item,index) in repertorymsg" :key="index">
          {{item.name}}:
          <i>{{item.value}}</i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    repertorymsg: {
      type: Array,
      default: () => {
        return [
          { value: "IFSDJDWE9389384", name: "批次信息" },
          { value: "2322", name: "货物数量" },
          { value: "222箱", name: "总货位数" },
          { value: "33", name: "托盘组" }
        ];
      }
    }
  },
  name: "echarts28",
  data() {
    return {};
  }
};
</script>
<style scoped>
.repertorymsg {
  width: 276px;
  height: 155px;
  position: relative;
  background:#00665E url("../../assets/img/echarts30.png")no-repeat;
}
.msg {
  width: 100%;
  position: absolute;
  top: 0px;
  line-height: 30px;
  left: 26px;
  font-size: 18px;
  color: #42beb6;
  border-radius: 4px;
  font-weight: 550;
}
.circle {
  background-color: #42beb6;
  border-radius: 4px;
  width: 8px;
  display: inline-block;
  height: 8px;
  margin-bottom: 2px;
}
.datadetails {
  position: absolute;
  width: 80%;
  left: 32px;
  top: 30px;
}
.datadetails div {
  width: 100%;
  line-height: 24px;
  text-align: left;
  color: #01fab9;
  font-weight: 550;
}
.datadetails div i {
  color: #fff;
  font-weight: 550;
}
</style>



// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts30.vue